import { useQuery } from '@tanstack/react-query'
import { useMemo } from 'react'
import { api, unwrap } from '@/api/client'
import type { Department } from '@/api/types'

/** Shared reference data used across multiple features. */

export function useDepartments() {
  return useQuery({
    queryKey: ['departments'],
    queryFn: () => unwrap(api.GET('/api/v1/departments')),
    staleTime: 5 * 60_000,
  })
}

export function useDepartmentMap(): Map<string, Department> {
  const { data } = useDepartments()
  return useMemo(() => {
    const map = new Map<string, Department>()
    for (const d of data?.items ?? []) map.set(d.id, d)
    return map
  }, [data])
}

export function useDelayReasons() {
  return useQuery({
    queryKey: ['delay-reasons'],
    queryFn: () => unwrap(api.GET('/api/v1/delay-reasons')),
    staleTime: 5 * 60_000,
  })
}

export function useRouteTemplatesList() {
  return useQuery({
    queryKey: ['route-templates'],
    queryFn: () => unwrap(api.GET('/api/v1/route-templates')),
    staleTime: 60_000,
  })
}
